/**
 * Logger conditionnel pour les widgets
 * N'affiche les logs qu'en développement
 * @module utils/logger
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Log un message d'erreur (uniquement en développement)
   * @param {string} message - Le message à logger
   * @param {...any} args - Arguments supplémentaires
   */
  error: (message, ...args) => {
    if (isDevelopment) {
      console.error(`[Widget Error] ${message}`, ...args);
    }
  },

  /**
   * Log un message d'avertissement (uniquement en développement)
   * @param {string} message - Le message à logger
   * @param {...any} args - Arguments supplémentaires
   */
  warn: (message, ...args) => {
    if (isDevelopment) {
      console.warn(`[Widget Warning] ${message}`, ...args);
    }
  },

  /**
   * Log un message d'information (uniquement en développement)
   * @param {string} message - Le message à logger
   * @param {...any} args - Arguments supplémentaires
   */
  info: (message, ...args) => {
    if (isDevelopment) {
      console.info(`[Widget Info] ${message}`, ...args);
    }
  },

  /**
   * Log un message de debug (uniquement en développement)
   * @param {string} message - Le message à logger
   * @param {...any} args - Arguments supplémentaires
   */
  debug: (message, ...args) => {
    if (isDevelopment) {
      console.log(`[Widget Debug] ${message}`, ...args);
    }
  },
};
